import styled from 'styled-components';
import { Box } from '@rsos/base-components';

export const AccordionContentWrapper = styled(Box).attrs({
  borderColor: 'lightLineDivider',
  borderRadius: '5px',
  borderWidth: '1px',
  borderStyle: 'solid',
  p: '16px',
  my: '16px',
  flow: 16,
})``;

export const Tag = styled(Box).attrs({
  bg: 'lightLineDivider',
  color: 'primaryText',
  borderRadius: '5px',
  px: '8px',
  py: '4px',
  horizontal: true,
  align: 'center',
  justify: 'space-between',
  flow: 4,
})``;

export const TagWrapper = styled(Box).attrs({
  horizontal: true,
  flexWrap: 'wrap',
  align: 'center',
  mt: '8px',
})`
  gap: 8px;
`;

export const CommentWrapper = styled(Box).attrs({})`
  gap: 16px;
`;

export const Comment = styled(Box).attrs({
  horizontal: true,
  align: 'flex-start',
  justify: 'space-between',
  flow: 8,
  borderRadius: '5px',
  border: '1px solid',
  borderColor: 'lightLineDivider',
  px: '16px',
  py: '8px',
})``;

export const Avatar = styled(Box).attrs({
  bg: 'lightLineDivider',
  color: 'secondaryText',
  borderRadius: '50%',
  width: '22px',
  height: '22px',
  align: 'center',
  justify: 'center',
})``;

export const EditButton = styled.button<{ isEditing: boolean }>`
  background: ${p => (p.isEditing ? p.theme.colors.highlights : 'none')};
  border: ${p => (p.isEditing ? p.theme.colors.primaryBase : 'none')};
  border-radius: ${p => (p.isEditing ? '5px' : 'none')};
  cursor: pointer;
  color: ${p => p.theme.colors.primaryBase};
  &:hover {
    color: ${p => p.theme.colors.primaryText};
  }
`;

export const ShareLinkContainer = styled(Box).attrs({
  border: '1px solid',
  borderColor: 'lightLineDivider',
  borderRadius: '4px',
  p: '16px',
  mb: '8px',
  bg: 'background',
})`
  word-break: break-all;
`;
